import type { FaireProductEntity } from "../../entity_types/product";

export const p_kr7qbmp4qa: FaireProductEntity = {
  token: "p_kr7qbmp4qa",
  type: "product",
  name: "Butterfly Sequin Quilted Crossbody Bag",
  brandToken: "b_3jxtednxl5",
  brandName: "OMG Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/be5ed33aff65ef1d20c2aac2b0a7d00d6e4bc86efa54c96cd4ab71d7a15bfb83.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/413cf7bd253ff1e04c6e0b146409efcbb8507fbfc99daf2ab77ca245ffb81cda.jpeg",
  ],
  priceDollars: 14,
  description:
    'Calling all butterfly lovers! Our round, pink, quilted, and metallic butterfly crossbody bag will make your mini want to spread their wings and fly! Detailed with a sequin bow, stylish pearl top handle, and an adjustable crossbody strap for the perfect fit.\n\nDimensions\n\n5.5"H x 7.5"W x 2"D\n\n\n',
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:02.127Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
